// src/components/trips-navigation.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsNavigateToViewActionFragment on TripsNavigateToViewAction {\n    __typename\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    tripItemId\n    tripViewId\n    viewFilter {\n      filter\n    }\n    viewType\n    viewUrl\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsSecondaryButtonFragment on TripsSecondaryButton {\n    __typename\n    primary\n    icon {\n      description\n      id\n    }\n    disabled\n    action {\n      ...TripsNavigateToViewActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClickstreamAnalyticsFragment on ClickstreamAnalytics {\n    event {\n      clickstreamTraceId\n      eventCategory\n      eventName\n      eventType\n      eventVersion\n    }\n    payload {\n      ... on TripRecommendationModule {\n        title\n        responseId\n        recommendations {\n          id\n          position\n          priceDisplayed\n          currencyCode\n          name\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClientSideImpressionAnalyticsFragment on ClientSideImpressionAnalytics {\n    uisPrimeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    clickstreamAnalytics {\n      ...ClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsFullBleedImageCardFragment on TripsFullBleedImageCard {\n    primary\n    secondaries\n    background {\n      url\n      description\n    }\n    icons {\n      id\n      description\n    }\n    action {\n      ...TripsNavigateToViewActionFragment\n    }\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n    accessibility {\n      label\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsIllustrationCardFragment on TripsIllustrationCard {\n    primary\n    secondaries\n    illustration {\n      url\n      description\n    }\n    impressionTracking {\n      ...ClientSideImpressionAnalyticsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ContentTextItemFragment on TripsContentTextItem {\n    __typename\n    icon {\n      __typename\n      description\n      id\n      title\n    }\n    primary\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ContentParagraphFragment on TripsContentParagraph {\n    __typename\n    primary\n    secondaries\n    items {\n      ...ContentTextItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsViewContentItemFragment on TripsViewContentItem {\n    __typename\n    primary\n    icon {\n      id\n      description\n      title\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsViewContentLineItemFragment on TripsViewContentLineItem {\n    __typename\n    items {\n      __typename\n      ...TripsViewContentItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsViewContentListFragment on TripsContentList {\n    __typename\n    primary\n    secondaries\n    listTheme: theme\n    items {\n      ...TripsViewContentLineItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsContentCardFragment on TripsContentCard {\n    __typename\n    primary\n    secondaries\n    rows {\n      ...ContentParagraphFragment\n      ...TripsViewContentListFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsSectionContainerFragment on TripsSectionContainer {\n    __typename\n    heading\n    theme\n    elements {\n      ...TripsFullBleedImageCardFragment\n      ...TripsSecondaryButtonFragment\n      ...TripsContentCardFragment\n      ...TripsIllustrationCardFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsListComponentFragment on TripsView {\n    __typename\n    elements {\n      ...TripsSectionContainerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  query TripsNavigationPackageQuery($context: ContextInput!) {\n    trips(context: $context) {\n      navigation {\n        ...TripsListComponentFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
import React20 from "react";
import { gql as gql16, useLazyQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
// src/components/__private/__fragments/trips-list-component.tsx
import React18 from "react";
import { gql as gql15 } from "@apollo/client";
// src/utils/trips-composable-element-list.tsx
import React from "react";
var tripsComposableElementList = function(elements, components) {
    if (!(elements === null || elements === void 0 ? void 0 : elements.length)) {
        return null;
    }
    return elements.map(function(composableElement, index) {
        var _Component_getKey;
        var __typename = composableElement.__typename;
        var Component = components.find(function(component) {
            return component.fragment.__typename === __typename;
        });
        if (!Component) {
            return null;
        }
        var _Component_getKey1;
        var key = (_Component_getKey1 = (_Component_getKey = Component.getKey) === null || _Component_getKey === void 0 ? void 0 : _Component_getKey.call(Component, composableElement)) !== null && _Component_getKey1 !== void 0 ? _Component_getKey1 : "trips-composable-element";
        return /* @__PURE__ */ React.createElement(Component, {
            key: "".concat(key.toLowerCase(), "-").concat(index),
            data: composableElement
        });
    });
};
// src/components/__private/__fragments/containers/section-container.tsx
import React17 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
// src/components/__private/__fragments/action-elements/secondary-button.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
// ../internal/src/components/actions/trips-navigate-to-view-action.ts
import { gql } from "@apollo/client";
import { useNavigation } from "@shared-ui/navigation-context";
// ../internal/src/components/state/mutation-action-state.ts
import { makeVar } from "@apollo/client";
var mutationActionState = makeVar(void 0);
// ../internal/src/components/actions/trips-navigate-to-view-action.ts
var __TripsNavigateToViewActionFragment = gql(_templateObject());
var useTripsNavigateToViewAction = function(data) {
    var navigate = useNavigation().navigate;
    if (data.__typename !== "TripsNavigateToViewAction") {
        return void 0;
    }
    var viewUrl = data.viewUrl;
    if (!viewUrl) {
        return {};
    }
    var clickEvent = navigate && {
        onClick: function(event) {
            return navigate({
                event: event,
                absoluteURL: viewUrl
            });
        }
    };
    return _objectSpread({
        href: viewUrl
    }, clickEvent);
};
// src/components/__private/__fragments/action-elements/secondary-button.tsx
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/__private/__fragments/actions/action-hook.ts
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var useInvalidAction = function() {
    return void 0;
};
var ActionMap = {
    TripsInvalidValidAction: useInvalidAction,
    TripsNavigateToViewAction: useTripsNavigateToViewAction,
    TripsDismissAction: function() {
        return {};
    }
};
function isValidActionType(action) {
    return Boolean(action && Object.keys(ActionMap).find(function(validAction) {
        return action.__typename === validAction;
    }));
}
var useActionMap = function(navAction) {
    var clickTracker = useClickTracker();
    var action = isValidActionType(navAction) ? navAction : {
        __typename: "TripsInvalidValidAction"
    };
    var hookResponse = ActionMap[action.__typename](action);
    if (action.__typename === "TripsInvalidValidAction" || !hookResponse) {
        return {};
    }
    return _objectSpread({
        onClickCapture: function() {
            var uisPrimeMessages = action.analytics.uisPrimeMessages.map(function(value) {
                return {
                    messageContent: JSON.parse(value.messageContent),
                    schemaName: value.schemaName
                };
            });
            clickTracker(action.analytics.referrerId, action.analytics.linkName, false, uisPrimeMessages);
        }
    }, hookResponse);
};
// src/components/__private/__fragments/action-elements/secondary-button.tsx
var __Fragment = gql2(_templateObject1(), __TripsNavigateToViewActionFragment);
var SecondaryButton = function(props) {
    var data = props.data;
    var actionProps = useActionMap(data === null || data === void 0 ? void 0 : data.action);
    if (!(data === null || data === void 0 ? void 0 : data.primary)) {
        return null;
    }
    var primary = data.primary, icon = data.icon, disabled = data.disabled;
    return /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkSecondaryButton, _objectSpreadProps(_objectSpread({
        disabled: disabled
    }, actionProps), {
        isFullWidth: true
    }), icon && /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: icon.id,
        size: UitkIconSize.MEDIUM
    }), primary)));
};
SecondaryButton.displayName = "SecondaryButton";
SecondaryButton.fragment = __Fragment;
SecondaryButton.fragment.__typename = "TripsSecondaryButton";
// src/components/__private/__fragments/cards/full-bleed-image-card.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
// ../internal/src/components/analytics/client-side-impression-analytics-intersection-tracker.tsx
import React3 from "react";
import { IntersectionTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/eg-clickstream-helper.ts
var egRecommendationBuilder = function(recommendation) {
    return {
        recommendation_id: recommendation.id,
        recommendation_position: recommendation.position,
        presentation_details_price_displayed: recommendation.priceDisplayed,
        presentation_details_currency_code: recommendation.currencyCode,
        presentation_details_recommendation_name: recommendation.name
    };
};
var buildClickstreamAnalyticsEvent = function(clickstreamAnalytics) {
    var _clickstreamAnalytics_event = clickstreamAnalytics.event, clickstreamTraceId = _clickstreamAnalytics_event.clickstreamTraceId, eventName = _clickstreamAnalytics_event.eventName, eventType = _clickstreamAnalytics_event.eventType, eventVersion = _clickstreamAnalytics_event.eventVersion, eventCategory = _clickstreamAnalytics_event.eventCategory;
    var _clickstreamAnalytics_payload = clickstreamAnalytics.payload, title = _clickstreamAnalytics_payload.title, responseId = _clickstreamAnalytics_payload.responseId, recommendations = _clickstreamAnalytics_payload.recommendations;
    return {
        event: {
            clickstream_trace_id: clickstreamTraceId,
            event_name: eventName,
            event_version: eventVersion,
            event_type: eventType,
            event_category: eventCategory
        },
        recommendation_module: {
            recommendation_title: title,
            eg_recommendation_response_id: responseId,
            recommendations: recommendations.map(function(recommendation) {
                return egRecommendationBuilder(recommendation);
            })
        }
    };
};
// ../internal/src/components/analytics/fragments/client-side-impression-analytics-fragment.ts
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/analytics/fragments/clickstream-analytics-fragment.ts
import { gql as gql3 } from "@apollo/client";
var ClickstreamAnalyticsFragment = gql3(_templateObject2());
// ../internal/src/components/analytics/fragments/client-side-analytics-fragment.ts
import { gql as gql4 } from "@apollo/client";
var ClientSideAnalyticsFragment = gql4(_templateObject3());
// ../internal/src/components/analytics/fragments/client-side-impression-analytics-fragment.ts
var __ClientSideImpressionAnalyticsFragment = gql5(_templateObject4(), ClientSideAnalyticsFragment, ClickstreamAnalyticsFragment);
// ../internal/src/components/analytics/client-side-impression-analytics-intersection-tracker.tsx
var ClientSideImpressionAnalyticsIntersectionTracker = function(param) {
    var data = param.data, children = param.children;
    var track = useEgClickstream();
    React3.useEffect(function() {
        if (data.clickstreamAnalytics) {
            track(buildClickstreamAnalyticsEvent(data.clickstreamAnalytics));
        }
    }, [
        data.clickstreamAnalytics,
        track
    ]);
    return data.uisPrimeAnalytics ? /* @__PURE__ */ React3.createElement(IntersectionTracker, {
        referrerId: data.uisPrimeAnalytics.referrerId,
        linkName: data.uisPrimeAnalytics.linkName,
        intersectionOptions: {
            threshold: 0.5
        }
    }, children) : /* @__PURE__ */ React3.createElement(React3.Fragment, null, children);
};
ClientSideImpressionAnalyticsIntersectionTracker.displayName = "ClientSideImpressionAnalyticsIntersectionTracker";
ClientSideImpressionAnalyticsIntersectionTracker.fragment = __ClientSideImpressionAnalyticsFragment;
// ../internal/src/components/analytics/client-side-impression-analytics-tracker.tsx
import React4 from "react";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var ClientSideImpressionAnalyticsTracker = function(param) {
    var data = param.data, children = param.children;
    var track = useClickstreamAnalytics().track;
    React4.useEffect(function() {
        if (data.uisPrimeAnalytics) {
            track(ITrackType.EVENT, {
                data: {
                    schemaName: "referrer",
                    messageContent: {
                        referrerId: data.uisPrimeAnalytics.referrerId,
                        linkName: data.uisPrimeAnalytics.linkName,
                        eventType: "impression"
                    }
                }
            });
        }
    }, [
        data.uisPrimeAnalytics,
        track
    ]);
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, children);
};
ClientSideImpressionAnalyticsTracker.displayName = "ClientSideImpressionAnalyticsTracker";
ClientSideImpressionAnalyticsTracker.fragment = __ClientSideImpressionAnalyticsFragment;
// src/components/__private/__fragments/cards/full-bleed-image-card.tsx
import { UitkBadge, UitkBadgeTheme } from "uitk-react-badge";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkScrim } from "uitk-react-scrim";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
// src/components/helper/trips-image.tsx
import React5 from "react";
import { UitkImage } from "uitk-react-images";
var TripsImage = function(param) {
    var src = param.src, alt = param.alt, _param_placeholderImage = param.placeholderImage, placeholderImage = _param_placeholderImage === void 0 ? true : _param_placeholderImage;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, src ? /* @__PURE__ */ React5.createElement(UitkImage, {
        src: src,
        alt: alt,
        placeholderImage: placeholderImage
    }) : /* @__PURE__ */ React5.createElement("div", {
        "data-stid": "placeholder-image",
        className: "uitk-image-placeholder uitk-image-placeholder-image"
    }));
};
// src/components/__private/__fragments/cards/full-bleed-image-card.tsx
var __Fragment2 = gql6(_templateObject5(), __TripsNavigateToViewActionFragment, ClientSideImpressionAnalyticsIntersectionTracker.fragment);
var FullBleedImageCard = function(param) {
    var data = param.data;
    var actionProps = useActionMap(data === null || data === void 0 ? void 0 : data.action);
    if (!data.primary) {
        return null;
    }
    var accessibility = data.accessibility, impressionTracking = data.impressionTracking, background = data.background, primary = data.primary, secondaries = data.secondaries, icons = data.icons;
    var fullBleedImageCard = /* @__PURE__ */ React6.createElement(UitkSpacing2, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React6.createElement(UitkCard, {
        overflow: true
    }, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(UitkFigure, {
        className: "uitk-card-roundcorner-all",
        ratio: UitkFigureAspectRatioType.R16_9
    }, /* @__PURE__ */ React6.createElement(TripsImage, {
        src: background === null || background === void 0 ? void 0 : background.url,
        alt: background === null || background === void 0 ? void 0 : background.description
    }), (primary || secondaries || (icons === null || icons === void 0 ? void 0 : icons.length)) && /* @__PURE__ */ React6.createElement(UitkScrim, null, Array.isArray(icons) && /* @__PURE__ */ React6.createElement(UitkSpacing2, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React6.createElement("div", null, icons.map(function(headingIcon, headingIconIndex) {
        /* @__PURE__ */ return React6.createElement(UitkSpacing2, {
            margin: headingIconIndex > 0 ? {
                inlinestart: "one"
            } : "unset",
            key: "trip-headingIcon-badge-".concat(headingIconIndex)
        }, /* @__PURE__ */ React6.createElement(UitkBadge, {
            theme: UitkBadgeTheme.NOTIFICATION_2
        }, /* @__PURE__ */ React6.createElement(UitkIcon2, {
            id: headingIcon.id.toLowerCase(),
            name: headingIcon.id.toLowerCase(),
            size: UitkIconSize2.SMALL,
            key: "trip-headingIcon-".concat(headingIconIndex),
            description: headingIcon === null || headingIcon === void 0 ? void 0 : headingIcon.description,
            title: headingIcon === null || headingIcon === void 0 ? void 0 : headingIcon.description
        })));
    }))), primary && /* @__PURE__ */ React6.createElement(UitkHeading, {
        size: 4
    }, primary), secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function(subheading, subheadingIndex) {
        return /* @__PURE__ */ React6.createElement(UitkText, {
            size: 300,
            key: "trip-subheading-".concat(subheadingIndex)
        }, subheading);
    }))), actionProps && (actionProps.href || actionProps.onClick) && /* @__PURE__ */ React6.createElement(UitkCardLink, null, actionProps.href && /* @__PURE__ */ React6.createElement("a", _objectSpread({}, actionProps), accessibility === null || accessibility === void 0 ? void 0 : accessibility.label), !actionProps.href && /* @__PURE__ */ React6.createElement("div", _objectSpread({}, actionProps))))));
    return impressionTracking ? /* @__PURE__ */ React6.createElement(ClientSideImpressionAnalyticsIntersectionTracker, {
        data: impressionTracking
    }, fullBleedImageCard) : fullBleedImageCard;
};
FullBleedImageCard.displayName = "FullBleedImageCard";
FullBleedImageCard.fragment = __Fragment2;
FullBleedImageCard.fragment.__typename = "TripsFullBleedImageCard";
// src/components/__private/__fragments/cards/illustration-card.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkIllustrations } from "uitk-react-illustrations";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText2 } from "uitk-react-text";
var __Fragment3 = gql7(_templateObject6(), ClientSideImpressionAnalyticsIntersectionTracker.fragment);
var IllustrationCard = function(param) {
    var data = param.data;
    var primary = data.primary, secondaries = data.secondaries, illustration = data.illustration, impressionTracking = data.impressionTracking;
    var illustrationCard = /* @__PURE__ */ React7.createElement(UitkSpacing3, {
        margin: {
            blockstart: "twelve",
            blockend: "twelve"
        }
    }, /* @__PURE__ */ React7.createElement(UitkCard2, null, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        justifyContent: "center",
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React7.createElement(React7.Fragment, null, (illustration === null || illustration === void 0 ? void 0 : illustration.url) && /* @__PURE__ */ React7.createElement(UitkIllustrations, {
        alt: illustration.description,
        url: illustration.url
    }), (primary || secondaries && secondaries.length > 0) && /* @__PURE__ */ React7.createElement(UitkSpacing3, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React7.createElement("div", null, primary && /* @__PURE__ */ React7.createElement(UitkHeading2, {
        size: 5
    }, primary), secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function(subheading, subheadingIndex) {
        return /* @__PURE__ */ React7.createElement(UitkText2, {
            size: 300,
            key: "trip-illustration-subheading-".concat(subheadingIndex)
        }, subheading);
    })))))));
    return impressionTracking ? /* @__PURE__ */ React7.createElement(ClientSideImpressionAnalyticsIntersectionTracker, {
        data: impressionTracking
    }, illustrationCard) : illustrationCard;
};
IllustrationCard.displayName = "TripsIllustrationCardFragment";
IllustrationCard.fragment = __Fragment3;
IllustrationCard.fragment.__typename = "TripsIllustrationCard";
// src/components/__private/__fragments/cards/content-card/content-card.tsx
import React16 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkSubheading } from "uitk-react-text";
// src/components/__private/__fragments/cards/content-card/content-paragraph.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText3 } from "uitk-react-text";
// src/components/__private/__fragments/cards/content-card/content-item/content-text-item.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
var __Fragment4 = gql8(_templateObject7());
var ContentTextItem = function(props) {
    var data = props.data;
    if (!data) {
        return null;
    }
    var primary = data.primary, icon = data.icon;
    if (!primary && !icon) {
        return null;
    }
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, icon && /* @__PURE__ */ React8.createElement(UitkIcon3, {
        name: icon.id,
        description: icon.description || "",
        title: icon.title || "",
        id: icon.id || ""
    }), primary);
};
ContentTextItem.displayName = "ContentTextItem";
ContentTextItem.fragment = __Fragment4;
ContentTextItem.fragment.__typename = "TripsContentTextItem";
// src/components/__private/__fragments/cards/content-card/content-paragraph.tsx
var __Fragment5 = gql9(_templateObject8(), ContentTextItem.fragment);
var validContentItemComponents = [
    ContentTextItem
];
var ContentParagraph = function(props) {
    var data = props.data;
    if (!data) {
        return null;
    }
    var primary = data.primary, secondaries = data.secondaries, items = data.items;
    if (!primary && !secondaries && !(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    var secondaryTag = primary ? "h5" : "h4";
    return /* @__PURE__ */ React9.createElement("div", null, primary && /* @__PURE__ */ React9.createElement(UitkSpacing4, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(UitkHeading3, {
        tag: "h3",
        size: 5
    }, primary))), Array.isArray(secondaries) && secondaries.map(function(secondary, secondaryIndex) {
        return /* @__PURE__ */ React9.createElement(UitkSpacing4, {
            key: "paragraph-secondary-".concat(secondaryIndex),
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(UitkHeading3, {
            tag: secondaryTag,
            size: 7
        }, secondary)));
    }), Array.isArray(items) && items.map(function(item, itemIndex) {
        var _ContentItem2_getKey;
        var __typename = (item || {}).__typename;
        var ContentItem2 = validContentItemComponents.find(function(component) {
            return component.fragment.__typename === __typename;
        });
        if (!ContentItem2) {
            return null;
        }
        var _ContentItem2_getKey1;
        var key = (_ContentItem2_getKey1 = (_ContentItem2_getKey = ContentItem2.getKey) === null || _ContentItem2_getKey === void 0 ? void 0 : _ContentItem2_getKey.call(ContentItem2, item)) !== null && _ContentItem2_getKey1 !== void 0 ? _ContentItem2_getKey1 : "trips-composable-element";
        return /* @__PURE__ */ React9.createElement(UitkText3, {
            size: 300,
            key: "".concat(__typename, "-").concat(key.toLowerCase(), "-").concat(itemIndex),
            spacing: "two"
        }, /* @__PURE__ */ React9.createElement(ContentItem2, {
            data: item
        }));
    }));
};
ContentParagraph.displayName = "ContentParagraph";
ContentParagraph.fragment = __Fragment5;
ContentParagraph.fragment.__typename = "TripsContentParagraph";
// src/components/__private/__fragments/cards/content-card/view-content/view-content-list.tsx
import React15 from "react";
import { gql as gql12 } from "@apollo/client";
// src/components/__private/__fragments/cards/content-card/parent-content/content-list.tsx
import React10 from "react";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText4 } from "uitk-react-text";
var ContentList = function(param) {
    var data = param.data, children = param.children;
    var primary = data.primary, secondaries = data.secondaries, listTheme = data.listTheme;
    if (!(primary || secondaries || children)) {
        return null;
    }
    var secondaryTag = primary ? "h4" : "h3";
    var listElement = function() {
        var listType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unordered", bulletType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default", keyName = arguments.length > 2 ? arguments[2] : void 0;
        return /* @__PURE__ */ React10.createElement(UitkSpacing5, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React10.createElement(UitkList, {
            type: listType,
            bullet: bulletType
        }, React10.Children.map(children, function(item, itemIndex) {
            return /* @__PURE__ */ React10.createElement(UitkListItem, {
                key: "".concat(keyName, "-").concat(itemIndex)
            }, /* @__PURE__ */ React10.createElement(UitkSpacing5, {
                margin: {
                    blockstart: "two"
                }
            }, /* @__PURE__ */ React10.createElement("div", null, item)));
        })));
    };
    var mainElement = {
        PARAGRAPH: React10.Children.map(children, function(item, itemIndex) {
            return /* @__PURE__ */ React10.createElement(UitkText4, {
                size: 300,
                key: "content-list-paragraph-item-".concat(itemIndex),
                spacing: "two"
            }, item);
        }),
        ORDERED: listElement("ordered", "default", "content-list-ordered-item"),
        BULLETS: listElement("unordered", "default", "content-list-unordered-item"),
        NO_BULLETS: listElement("unordered", "no-bullet", "content-list-unordered-no-bullets-item")
    }[listTheme];
    return /* @__PURE__ */ React10.createElement("div", null, primary && /* @__PURE__ */ React10.createElement(UitkSpacing5, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(UitkHeading4, {
        tag: "h3",
        size: 5
    }, primary))), Array.isArray(secondaries) && secondaries.map(function(secondary, secondaryIndex) {
        return /* @__PURE__ */ React10.createElement(UitkSpacing5, {
            key: "content-list-secondary-".concat(secondaryIndex),
            margin: {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(UitkHeading4, {
            tag: secondaryTag,
            size: 7
        }, secondary)));
    }), mainElement);
};
// src/components/__private/__fragments/cards/content-card/view-content/view-content-line-item.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
// src/components/__private/__fragments/cards/content-card/parent-content/content-line-item.tsx
import React11 from "react";
import { UitkText as UitkText5 } from "uitk-react-text";
var ContentLineItem = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React11.createElement(UitkText5, null, children);
};
// src/components/__private/__fragments/cards/content-card/view-content/view-content-item.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
// src/components/__private/__fragments/cards/content-card/parent-content/content-item.tsx
import React12 from "react";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
var ContentItem = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var primary = data.primary, icon = data.icon;
    if (!(data.primary || data.icon)) {
        return null;
    }
    return /* @__PURE__ */ React12.createElement(React12.Fragment, null, icon && /* @__PURE__ */ React12.createElement(UitkIcon4, {
        name: icon.id,
        description: icon.description || "",
        title: icon.title || "",
        id: icon.id || ""
    }), primary);
};
// src/components/__private/__fragments/cards/content-card/view-content/view-content-item.tsx
var __Fragment6 = gql10(_templateObject9());
var TripsViewContentItem = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React13.createElement(ContentItem, {
        data: data
    });
};
TripsViewContentItem.displayName = "ContentItem";
TripsViewContentItem.fragment = __Fragment6;
TripsViewContentItem.fragment.__typename = "TripsViewContentItem";
// src/components/__private/__fragments/cards/content-card/view-content/view-content-line-item.tsx
var __Fragment7 = gql11(_templateObject10(), TripsViewContentItem.fragment);
var TripsViewContentLineItem = function(param) {
    var data = param.data;
    var _data_items;
    if (!((_data_items = data.items) === null || _data_items === void 0 ? void 0 : _data_items.length)) {
        return null;
    }
    var items = data.items;
    var childElements = tripsComposableElementList(items, [
        TripsViewContentItem
    ]);
    return /* @__PURE__ */ React14.createElement(ContentLineItem, null, childElements);
};
TripsViewContentLineItem.displayName = "TripsViewContentLineItem";
TripsViewContentLineItem.fragment = __Fragment7;
TripsViewContentLineItem.fragment.__typename = "TripsViewContentLineItem";
// src/components/__private/__fragments/cards/content-card/view-content/view-content-list.tsx
var __Fragment8 = gql12(_templateObject11(), TripsViewContentLineItem.fragment);
var TripsViewContentList = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var items = data.items;
    var childElements = tripsComposableElementList(items, [
        TripsViewContentLineItem
    ]);
    return /* @__PURE__ */ React15.createElement(ContentList, {
        data: data
    }, childElements);
};
TripsViewContentList.displayName = "ContentList";
TripsViewContentList.fragment = __Fragment8;
TripsViewContentList.fragment.__typename = "TripsContentList";
// src/components/__private/__fragments/cards/content-card/content-card.tsx
var __Fragment9 = gql13(_templateObject12(), TripsViewContentList.fragment, ContentParagraph.fragment);
var ContentCard = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var primary = data.primary, secondaries = data.secondaries, rows = data.rows;
    if (!primary && !secondaries && !(rows === null || rows === void 0 ? void 0 : rows.length)) {
        return null;
    }
    var composableElements = tripsComposableElementList(rows, [
        TripsViewContentList,
        ContentParagraph
    ]);
    return /* @__PURE__ */ React16.createElement("div", null, primary && /* @__PURE__ */ React16.createElement(UitkSpacing6, {
        margin: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(UitkHeading5, {
        tag: "h3",
        size: 4
    }, primary))), Array.isArray(secondaries) && secondaries.map(function(subheading, subheadingIndex) {
        return /* @__PURE__ */ React16.createElement(UitkSubheading, {
            key: "paragraph-subheading-".concat(subheadingIndex)
        }, subheading);
    }), composableElements);
};
ContentCard.displayName = "ContentCard";
ContentCard.fragment = __Fragment9;
ContentCard.fragment.__typename = "TripsContentCard";
// src/components/__private/__fragments/containers/section-container.tsx
var __Fragment10 = gql14(_templateObject13(), FullBleedImageCard.fragment, SecondaryButton.fragment, ContentCard.fragment, IllustrationCard.fragment);
var SectionContainer = function(param) {
    var data = param.data;
    var _data_elements;
    if (!(data === null || data === void 0 ? void 0 : (_data_elements = data.elements) === null || _data_elements === void 0 ? void 0 : _data_elements.length)) {
        return null;
    }
    var elements = data.elements, heading = data.heading, theme = data.theme;
    var topSpacing = theme === "IMPORTANT" /* IMPORTANT */  ? "six" : "twelve";
    var composableElements = tripsComposableElementList(elements, [
        FullBleedImageCard,
        SecondaryButton,
        ContentCard,
        IllustrationCard
    ]);
    return /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            inline: "six"
        },
        margin: {
            blockstart: topSpacing
        }
    }, /* @__PURE__ */ React17.createElement("section", null, heading && /* @__PURE__ */ React17.createElement(UitkHeading6, {
        tag: "h2",
        size: 4
    }, heading), composableElements));
};
SectionContainer.displayName = "SectionContainer";
SectionContainer.fragment = __Fragment10;
SectionContainer.fragment.__typename = "TripsSectionContainer";
// src/components/__private/__fragments/trips-list-component.tsx
var __Fragment11 = gql15(_templateObject14(), SectionContainer.fragment);
var TripsListComponent = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var elements = data.elements;
    if (!(elements === null || elements === void 0 ? void 0 : elements.length)) {
        return null;
    }
    var composableElements = tripsComposableElementList(elements, [
        SectionContainer
    ]);
    return /* @__PURE__ */ React18.createElement(React18.Fragment, null, composableElements);
};
TripsListComponent.displayName = "TripsListComponent";
TripsListComponent.fragment = __Fragment11;
TripsListComponent.fragment.__typename = "TripsView";
// src/components/__private/error-view.tsx
import React19, { useEffect } from "react";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
import { usePageTitle } from "@shared-ui/page-title-context";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7 } from "uitk-react-text";
var EVENTS = {
    TRIPS_ERROR_VIEW: new SystemEvent(SystemEventLevel.ERROR, "TRIPS_ERROR_VIEW"),
    TRIPS_ERROR_VIEW_RETRY_INFO: new SystemEvent(SystemEventLevel.INFO, "TRIPS_ERROR_VIEW_RETRY_INFO")
};
var ErrorView = function(props) {
    var error = props.error, referrerId = props.referrerId, linkName = props.linkName, refetch = props.refetch;
    var formatText = useLocalization().formatText;
    var clickTracker = useClickTracker2();
    var setPageTitle = usePageTitle().setPageTitle;
    var logger = useLoggerEvents(EVENTS);
    useEffect(function() {
        setPageTitle({
            isError: true
        });
        logger.TRIPS_ERROR_VIEW.log(error);
    }, [
        error,
        logger,
        setPageTitle
    ]);
    var errorMessage = typeof window !== "undefined" && !navigator.onLine ? formatText("trip.error.offline.message") : formatText("trip.error.message");
    var tryAgainLabel = formatText("trip.try.again.label");
    var smallBreakpointMaxWidth = 575;
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, errorMessage && tryAgainLabel && /* @__PURE__ */ React19.createElement(UitkLayoutFlex2, {
        justifyContent: "center"
    }, /* @__PURE__ */ React19.createElement(UitkSpacing8, {
        margin: {
            blockstart: "twelve"
        },
        padding: {
            inlineend: "six",
            inlinestart: "six"
        }
    }, /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem, {
        maxWidth: smallBreakpointMaxWidth
    }, /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(UitkHeading7, {
        tag: "h3",
        size: 4
    }, errorMessage), /* @__PURE__ */ React19.createElement(UitkSpacing8, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(UitkPrimaryButton, {
        isFullWidth: true,
        onClick: function() {
            refetch();
            clickTracker(referrerId, linkName);
            logger.TRIPS_ERROR_VIEW_RETRY_INFO.log({
                message: "Attempting to re-query this view ".concat(linkName)
            });
        }
    }, tryAgainLabel)))))))));
};
// src/components/__private/tracking-events.ts
var TrackEvents = {
    TripNavigation: {
        rffrId: "TN.NAV.Retry"
    }
};
var LinkName = {
    TryAgain: "Try again"
};
// src/components/trips-navigation.tsx
var __Query = gql16(_templateObject15(), TripsListComponent.fragment);
var TripsNavigation = function() {
    var _data_trips;
    var context = useBexApi().context;
    var variables = {
        context: context
    };
    var _useLazyQuery = _slicedToArray(useLazyQuery(__Query, {
        variables: variables,
        fetchPolicy: "cache-and-network",
        errorPolicy: "all",
        notifyOnNetworkStatusChange: true
    }), 2), fetchData = _useLazyQuery[0], _useLazyQuery_ = _useLazyQuery[1], called = _useLazyQuery_.called, data = _useLazyQuery_.data, loading = _useLazyQuery_.loading, error = _useLazyQuery_.error, refetch = _useLazyQuery_.refetch;
    React20.useEffect(function() {
        fetchData();
    }, [
        fetchData
    ]);
    if (error && !data && refetch) {
        return /* @__PURE__ */ React20.createElement(ErrorView, {
            refetch: refetch,
            error: error,
            referrerId: TrackEvents.TripNavigation.rffrId,
            linkName: LinkName.TryAgain
        });
    }
    return /* @__PURE__ */ React20.createElement(React20.Fragment, null, called && loading && !data && /* @__PURE__ */ React20.createElement(UitkLayoutFlex3, {
        justifyContent: "center"
    }, /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React20.createElement(UitkLoader, null)))), (data === null || data === void 0 ? void 0 : (_data_trips = data.trips) === null || _data_trips === void 0 ? void 0 : _data_trips.navigation) && /* @__PURE__ */ React20.createElement(TripsListComponent, {
        data: data === null || data === void 0 ? void 0 : data.trips.navigation
    }));
};
TripsNavigation.displayName = "TripsNavigation";
export { TripsNavigation, tripsComposableElementList };
//# sourceMappingURL=index.js.map